import { NewsfeedResponseDto } from '@epicuro-next/data/engagement/engagement-models';
import { DynamicItemsConfigEntry } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';
import { createAction, props } from '@ngrx/store';

import { PaneLocation, PBasketView, State } from '../model';

export const setAsideMenuOpenedState = createAction(
  '[User UI] Set aside menu opened state',
  props<{ opened: boolean }>(),
);

export const setUserMenuOpenedState = createAction(
  '[User UI] Set user menu opened state',
  props<{ opened: boolean }>(),
);

export const toggleAsideMenuOpenedState = createAction(
  '[User UI] Toggle aside menu opened state',
);

export const setUserUiState = createAction('[User UI] Set user ui state');
export const loadUserUiState = createAction('[User UI] Load user ui state');
export const loadUserUiStateSuccess = createAction(
  '[User UI] Load user ui state success',
  props<{ state: State }>(),
);

/**
 * Updating main header height
 */
export const setMainHeaderHeight = createAction(
  '[User UI] Update Main Header Height',
  props<{ height: number }>(),
);

export const setPromotedLandingPageFeed = createAction(
  '[User UI] Set promoted landing page feed',
  props<{ feed: NewsfeedResponseDto | null }>(),
);

export const toggleFeedView = createAction(
  '[User UI] Toggle feed view',
  props<{ singleColumnView: boolean }>(),
);

export const toggleWaitingNewOrder = createAction(
  '[User UI] Toggle Waiting New Order',
  props<{ waitingNewOrder: boolean }>(),
);

export const updatePresetValue = createAction(
  '[User UI] Update Preset Value',
  props<{ presetFilter: string }>(),
);

export const showLoaderOverlay = createAction('[User UI] Show Loader Overlay');

export const hideLoaderOverlay = createAction(
  '[User UI] Hide Loader Overlay',
  props<{ delay?: number }>(),
);

export const setPBasketView = createAction(
  '[User UI] Set PBasket View',
  props<{ pBasketView: PBasketView }>(),
);

export const toggleProductDetails = createAction(
  '[User UI] Toggle Product Details',
  props<{ expanded: boolean }>(),
);

export const setPane = createAction(
  '[User UI] Set Pane',
  props<{
    location: PaneLocation;
    content: DynamicItemsConfigEntry[];
    title?: string;
    settings?: {
      showCloseButton?: boolean;
      backdropClass?: string;
      className?: string;
      fancyItemId?: string;
      parentItemId?: string;
      isSelected?: boolean;
    };
  }>(),
);

export const clearPane = createAction(
  '[User UI] Clear Pane',
  props<{
    location: PaneLocation;
  }>(),
);
